<template>
  <artmisads-modal :open="true" title="Payment Details" :width="1300" :onCancel="() => props.setDetailData({})"
    :destroyOnClose="true" :footer="null">
    <a-spin :spinning="spinning">
      <div class="payment">
        <div class="info">
          <div class="head">
            <p>Payment Info</p>
            <artmisads-select-button @click="toInvoicePdf">
              <svg class="icon icon-daochu1" aria-hidden="true">
                <use xlink:href="#icon-daochu1"></use>
              </svg>
              Download Statement
            </artmisads-select-button>
          </div>
          <div class="tag">
            <div class="item date">
              <span class="line"></span>
              <div class="text">
                <span class="name">Invoice Date:</span>
                <span class="num">{{ moment(props.detailData.billingDateTimestamp).format('YYYY-MM') }}</span>
              </div>
            </div>
            <div class="item payment-id">
              <span class="line"></span>
              <div class="text">
                <span class="name">Payment ID:</span>
                <span class="num">{{ props.detailData.billingId }}</span>
              </div>
            </div>
            <div class="item type">
              <span class="line"></span>
              <div class="text">
                <span class="name">Payment Type:</span>
                <span class="num">{{ setBillingType(props.detailData.billingType) }}</span>
              </div>
            </div>
            <div class="item amount">
              <span class="line"></span>
              <div class="text">
                <span class="name">Payment Amount :</span>
                <span class="num" v-if="props.detailData.billingType == 'MONTHLY'">
                  {{ AMAZON_CURRENCY_MAPPER[props.detailData.marketplace] }}{{ props.detailData.amount }}
                </span>
                <span class="num" v-else :class="props.detailData.amount? props.detailData.amount > 0 ? 'amount-plus' : 'amount-minus':''">
                  {{ setUnit(props.detailData.amount) }} {{ AMAZON_CURRENCY_MAPPER[props.detailData.marketplace] }}{{ setAmount(props.detailData.amount) }}
                </span>
              </div>
            </div>
            <div class="item marketplace">
              <span class="line"></span>
              <div class="text">
                <span class="name">Marketplace:</span>
                <div class="marketplace-tag">
                  <div>
                    <Icon :name="COUNTRY_BASE_MAP[props.detailData.marketplace].icon"></Icon>
                    <span>{{ props.detailData.marketplace }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="item status">
              <span class="line"></span>
              <div class="text">
                <span class="name">Payment Status:</span>
                <financeStatus :type="props.detailData.status"
                  v-if="props.detailData.displayStatus === 'Paid' || props.detailData.displayStatus === 'Not Paid' || props.detailData.displayStatus === ''" />
                <financeStatus :pageType="props.detailData.displayStatus" :pageTypeClass="props.detailData.status" v-else />
              </div>
            </div>
          </div>
        </div>
        <div class="detail">
          <p>Details</p>
          <div class="filter">
            <div class="button-groups">
              <buttonGroups :pagination="{
                total: listTotal,
                current: params.page,
                size: params.size,
              }" :tableData="list" @pageChange="onPageChange" />
              <artmisads-segmented-tabs style="margin: 0 0 0 10px;"  v-model="activeTab" :items="programConfig" />
            </div>
            <div class="filter-right-group">
              <div class="filter-right" ref="groupByType" v-if="activeTab=='0'">
                <artmisads-select allowClear style="width: 250px" class="country" :dropdownMatchSelectWidth="false"
                  v-model:value="params.groupByType" @change="(value) => changeGroupByType(value)"
                  :getPopupContainer="() => $refs.groupByType">
                  <a-select-option class="source-select-item" v-for="item in groupByTypeOptions" :key="item.id"
                    :value="item.id" :dataItem="item">
                    {{ item.name }}
                  </a-select-option>
                </artmisads-select>
                <a-popover class="wenhao-icon-wrap" v-if="params.groupByType==='by_tracking_id'">
                  <svg class="wenhao-icon icon" aria-hidden="true">
                   <use xlink:href="#icon-wenhao-tianchong"></use>
                  </svg>
                  <template #content>
                    <p class="tooltip-text">
                      Only the datas with Tracking IDs inserted into the links are displayed by this option.
                    </p>
                  </template>
                </a-popover>
               
              </div>
              <div class="search">
                <artmisads-select show-search v-model:value="params.brandId" style="width: 200px"
                  :options="brandOptions" @search="searchBrand" :show-arrow="false" :filter-option="false"
                  :not-found-content="null" placeholder="All" allowClear @change="onChangeBrand" />
                <artmisads-button-special @click="financePublisherBillingsDetailExport" v-if="activeTab!='2'&&activeTab!='3'">
                  <svg class="icon daochu" aria-hidden="true">
                    <use xlink:href="#icon-daochu"></use>
                  </svg>
                  <span class="btn-text">Export</span>
                  <svg class="icon artmisads-select-down-icon" aria-hidden="true">
                    <use xlink:href="#icon-jiantou-xia-cu"></use>
                  </svg>
                </artmisads-button-special>
              </div>
            </div>

          </div>
          <div class="table">
            <a-table
              :bordered="true"
             :columns="columns" row-key="id" :data-source="list" :pagination="{
              total: listTotal,
              current: params.page,
              pageSize: params.size,
              showSizeChanger: true
            }" @change="onChangePage">
              <template #bodyCell="{ column, record, text }">
                <template v-if="column.name === 'showCurrency'">
                  {{text||text==0? AMAZON_CURRENCY_MAPPER[props.marketplace] :'--'}}{{ text }}
                </template>
                <template v-if="column.name === 'amount'">
                  <div :class="text? text > 0 ? 'amount-plus' : 'amount-minus':''">
                    {{ setUnit(text) }} {{text||text==0? AMAZON_CURRENCY_MAPPER[props.marketplace] :''}}{{ setAmount(text) }}
                  </div>
                
                </template>
                <template v-if="column.dataIndex === 'artemisAdsPaymentStatus'">
                  <financeStatus :type="record.paymentStatus"/>
                  
            </template>
                <template v-if="column.dataIndex === 'platformFeeAmount'">
                  {{ record.platformFeeAmount }}%
                </template>

                <!-- <template v-if="column.name === 'commissions'">
                  {{ setUnit(text) }} {{ AMAZON_CURRENCY_MAPPER[props.marketplace] }}{{ setAmount(text) }}
                </template> -->
                  <template v-if="column.name === 'status'&&record.billingType==='MONTHLY'">
                    <financeStatus :type="text" v-if='params.groupByType!="by_tracking_id"'/>
                    <financeStatus :pageType="record.displayStatus" :pageTypeClass="record.status" v-else />
                  </template>
                  <template v-if="column.name === 'status'&&record.billingType!=='MONTHLY'">
                    <financeStatus :pageType="record.displayStatus" :pageTypeClass="record.status"/>
                  </template>
              </template>
            </a-table>
          </div>
        </div>
      </div>
    </a-spin>
  </artmisads-modal>
</template>

<script setup>
import { useRouter } from "vue-router"
import moment from 'moment'
import { keyBy } from 'lodash'
import Icon from '~/components/Icon.vue'
import { message, Modal } from "ant-design-vue"
import { AMAZON_CURRENCY_MAPPER } from '~/contants/common'
import financeStatus from '~/components/financeStatus'
import { ref, onBeforeMount, computed, onMounted, watch } from "vue"
import ButtonGroups from '~/pages/seller/Brands/components/buttonGroups.vue'

import { financePublisherApi, publisherReportsApi } from "~/server"

import { COUNTRY_BASE } from "~/contants/common"
import { useSystemStore } from '@/storeData/system'
const systemStore = useSystemStore()
const COUNTRY_BASE_MAP = keyBy(COUNTRY_BASE, 'host')

const router = useRouter()
const props = defineProps(["detailData", 'setDetailData', 'marketplace'])
const list = ref([])
const listTotal = ref(0)
const spinning = ref(false)
const brandOptions = ref([])
const activeTab = ref('0')
const programConfig = computed(() =>[...systemStore.programConfig,
{label:'Cost-Per-Click',key:'2'},
{label:'ACC Bonus',key:'3'}
])

const generateUniqueId = (item, index) => {
  return `${Date.now()}_${index}_${Math.random().toString(36).substr(2, 9)}`
}
const setBillingType = (value) => {
  if (value === undefined || value === null) return ''
  const str = String(value).toLowerCase()
  return str.charAt(0).toUpperCase() + str.slice(1)
}
const setUnit = (record) => {
if(record||record==0){
  if (record > 0) {
    return '+'
  }
  else if(record == 0){
    return ''
  }
  else {
    return '-'
  }
}
  else{
    return ''
  }
}
const setAmount = (record) => {
  if(record||record==0){
    return Math.abs(record)
  }
  else{
    return '--'
  }
}
const processDataWithId = (data) => {
  return data.map((item, index) => {
    const processedItem = {
      ...item,
      id: generateUniqueId(item, index)
    }
    if (processedItem.level === "PRIMARY") {
      processedItem.brandName = ''
    }
    if (processedItem.level === "SUB") {
      if (processedItem.publisherSubTrackingId) {
        processedItem.publisherPrimaryTrackingId = ''
      }
      processedItem.brandName = ''
    }
    if (item.children && Array.isArray(item.children) && item.children.length > 0) {
      processedItem.children = processDataWithId(item.children)
    }

    return processedItem
  })
}

const params = ref({
  page: 1,
  size: 10,
  brandId: null,
  groupByType: 'by_brands',
})
const groupByTypeOptions = ref([
  {
    id: 'by_brands',
    name: 'By Brands',
  },
  {
    id: 'by_tracking_id',
    name: 'By Tracking ID',
  },
  {
    id: 'by_brands_and_tracking_id',
    name: 'By Brands X Tracking ID',
  },
])
const billingBusinessSourceData=ref([
  'amazon_attribution',
  'amazon_associate',
  'cpc',
  'acc_bonus',
])
const columns = ref([

  {
    title: 'Brand',
    dataIndex: 'brandName',
    width: 120,
  },

  {
    title: 'Sales',
    dataIndex: 'saleCommissionAmount',
    width: 150,
    name: 'sales',
  },
  {
    title: 'Commissions',
    dataIndex: 'commissionAmount',
    width: 140,
    name: 'commissions',
  },
  {
    title: 'Brands Payment Status',
    dataIndex: 'status',
    name: 'status',
    width: 200,
  },
])

const onChangePage = (data, filters) => {
  
  const { current, pageSize } = data
  params.value.page = current
  params.value.size = pageSize
  getFinancePublisherBillingsDetail()
}
const changeGroupByType = (value) => {
  switch (value) {
    case 'by_brands':
      if(props.detailData.billingType == 'MONTHLY'){
      columns.value = [
        {
          title: 'Brand',
          dataIndex: 'brandName',
          width: 120,
        },
        {
          title: 'Sales',
          dataIndex: 'saleCommissionAmount',
          width: 150,
          name: 'showCurrency',
        },
        {
          title: 'Commissions',
          dataIndex: 'commissionAmount',
          width: 140,
          name: 'showCurrency',
        },
        {
          title: 'Brands Payment Status',
          dataIndex: 'status',
          name: 'status',
          width: 200,
        },
      ]
    }
    else{
      columns.value = [
        {
          title: 'Brand',
          dataIndex: 'brandName',
          width: 120,
        },
        {
          title: 'Sales',
          children: [
            {
              title: 'Original',
              dataIndex: 'previousSalesAmount',
              key: 'previousSalesAmount',
              name: 'showCurrency',
            },
            {
              title: 'Adjusted',
              dataIndex: 'finalSalesAmount',
              key: 'finalSalesAmount',
              name: 'showCurrency',
            },
            {
              title: 'Change',
              dataIndex: 'saleCommissionAmount',
              key: 'saleCommissionAmount',
              name: 'amount',
            }
          ],
        },
        {
          title: 'Commissions',
          dataIndex: 'commissionAmount',
          children: [
          {
              title: 'Original',
              dataIndex: 'previousCommissionAmount',
              key: 'previousCommissionAmount',
              name: 'showCurrency',
            },
            {
              title: 'Adjusted',
              dataIndex: 'finalCommissionAmount',
              key: 'finalCommissionAmount',
              name: 'showCurrency',
            },
            {
              title: 'Change',
              dataIndex: 'commissionAmount',
              key: 'commissionAmount',
              name: 'amount',
            }
          ],
        },
        {
          title: 'Brands Payment Status',
          dataIndex: 'status',
          name: 'status',
          width: 200,
        },
        {
          title:'ArtemisAdsPaymentStatus',
          dataIndex: 'artemisAdsPaymentStatus',
          width: 200,
        }
      ]
    }
      break
    case 'by_tracking_id':
    
      if(props.detailData.billingType == 'MONTHLY'){
      columns.value = [
        {
          title: 'Primary ID',
          dataIndex: 'publisherPrimaryTrackingId',
          width: 120,
        },
        {
          title: 'Sub ID',
          dataIndex: 'publisherSubTrackingId',
          width: 120,
        },
        {
          title: 'Sales',
          dataIndex: 'saleCommissionAmount',
          width: 150,
          name: 'showCurrency',
        },
        {
          title: 'Commissions',
          dataIndex: 'commissionAmount',
          width: 140,
          name: 'showCurrency',
        },
        {
          title: 'Brands Payment Status',
          dataIndex: 'status',
          name: 'status',
          width: 200,
        },
      ]}
      else{
        columns.value = [
        {
          title: 'Primary ID',
          dataIndex: 'publisherPrimaryTrackingId',
          width: 120,
        },
        {
          title: 'Sub ID',
          dataIndex: 'publisherSubTrackingId',
          width: 120,
        },
        {
          title: 'Sales',
          children: [
            {
              title: 'Original',
              dataIndex: 'previousSalesAmount',
              key: 'previousSalesAmount',
              name: 'showCurrency',
            },
            {
              title: 'Adjusted',
              dataIndex: 'finalSalesAmount',
              key: 'finalSalesAmount',
              name: 'showCurrency',
            },
            {
              title: 'Change',
              dataIndex: 'saleCommissionAmount',
              key: 'saleCommissionAmount',
              name: 'amount',
            }
          ],
        },
        {
          title: 'Commissions',
          dataIndex: 'commissionAmount',
          children: [
          {
              title: 'Original',
              dataIndex: 'previousCommissionAmount',
              key: 'previousCommissionAmount',
              name: 'showCurrency',
            },
            {
              title: 'Adjusted',
              dataIndex: 'finalCommissionAmount',
              key: 'finalCommissionAmount',
              name: 'showCurrency',
            },
            {
              title: 'Change',
              dataIndex: 'commissionAmount',
              key: 'commissionAmount',
              name: 'amount',
            }
          ],
        },
        {
          title: 'Brands Payment Status',
          dataIndex: 'status',
          name: 'status',
          width: 200,
        },
        {
          title:'ArtemisAdsPaymentStatus',
          dataIndex: 'artemisAdsPaymentStatus',
          width: 200,
        }
      ]}
      
      break
    case 'by_brands_and_tracking_id':
      if(props.detailData.billingType == 'MONTHLY'){
      columns.value = [
        {
          title: 'Brand',
          dataIndex: 'brandName',
          width: 120,
        },
        {
          title: 'Primary ID',
          dataIndex: 'publisherPrimaryTrackingId',
          width: 120,
        },
        {
          title: 'Sub ID',
          dataIndex: 'publisherSubTrackingId',
          width: 120,
        },
        {
          title: 'Sales',
          dataIndex: 'saleCommissionAmount',
          width: 150,
          name: 'showCurrency',
        },
        {
          title: 'Commissions',
          dataIndex: 'commissionAmount',
          width: 140,
          name: 'showCurrency',
        },
        {
          title: 'Brands Payment Status',
          dataIndex: 'status',
          name: 'status',
          width: 200,
        },
      ]}
      else{
        columns.value = [
        {
          title: 'Brand',
          dataIndex: 'brandName',
          width: 120,
        },
        {
          title: 'Primary ID',
          dataIndex: 'publisherPrimaryTrackingId',
          width: 120,
        },
        {
          title: 'Sub ID',
          dataIndex: 'publisherSubTrackingId',
          width: 120,
        },
        {
          title: 'Sales',
          children: [
            {
              title: 'Original',
              dataIndex: 'previousSalesAmount',
              key: 'previousSalesAmount',
              name: 'showCurrency',
            },
            {
              title: 'Adjusted',
              dataIndex: 'finalSalesAmount',
              key: 'finalSalesAmount',
              name: 'showCurrency',
            },
            {
              title: 'Change',
              dataIndex: 'saleCommissionAmount',
              key: 'saleCommissionAmount',
              name: 'amount',
            }
          ],
        },
        {
          title: 'Commissions',
          dataIndex: 'commissionAmount',
          children: [
          {
              title: 'Original',
              dataIndex: 'previousCommissionAmount',
              key: 'previousCommissionAmount',
              name: 'showCurrency',
            },
            {
              title: 'Adjusted',
              dataIndex: 'finalCommissionAmount',
              key: 'finalCommissionAmount',
              name: 'showCurrency',
            },
            {
              title: 'Change',
              dataIndex: 'commissionAmount',
              key: 'commissionAmount',
              name: 'amount',
            }
          ],
        },
        {
          title: 'Brands Payment Status',
          dataIndex: 'status',
          name: 'status',
          width: 200,
        },
        {
          title:'ArtemisAdsPaymentStatus',
          dataIndex: 'artemisAdsPaymentStatus',
          width: 200,
        }
      ]}
      
      break
    default:
      columns.value = [
        {
          title: 'Brand',
          dataIndex: 'brandName',
          width: 120,
        },
        {
          title: 'Sales',
          dataIndex: 'saleCommissionAmount',
          width: 150,
          name: 'showCurrency',
        },
        {
          title: 'Commissions',
          dataIndex: 'commissionAmount',
          width: 140,
          name: 'showCurrency',
        },
        {
          title: 'Brands Payment Status',
          dataIndex: 'status',
          name: 'status',
          width: 200,
        },
      ]
  }
  params.value.groupByType = value
  params.value.page = 1
  params.value.size = 10
  params.value.brandId = null
  getFinancePublisherBillingsDetail()
}
watch(() => activeTab.value, () => {
 
  if(activeTab.value==0){
    if(props.detailData.billingType == 'MONTHLY'){
      columns.value = [
        {
          title: 'Brand',
          dataIndex: 'brandName',
          width: 120,
        },
        {
          title: 'Sales',
          dataIndex: 'saleCommissionAmount',
          width: 150,
          name: 'showCurrency',
        },
        {
          title: 'Commissions',
          dataIndex: 'commissionAmount',
          width: 140,
          name: 'showCurrency',
        },
        {
          title: 'Brands Payment Status',
          dataIndex: 'status',
          name: 'status',
          width: 200,
        },
      ]
    }
    else{
      columns.value = [
        {
          title: 'Brand',
          dataIndex: 'brandName',
          width: 120,
        },
        {
          title: 'Sales',
          children: [
            {
              title: 'Original',
              dataIndex: 'previousSalesAmount',
              key: 'previousSalesAmount',
              name: 'showCurrency',
            },
            {
              title: 'Adjusted',
              dataIndex: 'finalSalesAmount',
              key: 'finalSalesAmount',
              name: 'showCurrency',
            },
            {
              title: 'Change',
              dataIndex: 'saleCommissionAmount',
              key: 'saleCommissionAmount',
              name: 'amount',
            }
          ],
        },
        {
          title: 'Commissions',
          dataIndex: 'commissionAmount',
          children: [
          {
              title: 'Original',
              dataIndex: 'previousCommissionAmount',
              key: 'previousCommissionAmount',
              name: 'showCurrency',
            },
            {
              title: 'Adjusted',
              dataIndex: 'finalCommissionAmount',
              key: 'finalCommissionAmount',
              name: 'showCurrency',
            },
            {
              title: 'Change',
              dataIndex: 'commissionAmount',
              key: 'commissionAmount',
              name: 'amount',
            }
          ],
        },
        {
          title: 'Brands Payment Status',
          dataIndex: 'status',
          name: 'status',
          width: 200,
        },
        {
          title:'ArtemisAdsPaymentStatus',
          dataIndex: 'artemisAdsPaymentStatus',
          width: 200,
        }
      ]
    }
  }
else if(activeTab.value==1){
  columns.value = [
        {
          title: 'Brand',
          dataIndex: 'brandName',
          width: 120,
        },
        {
          title: 'Sales',
          dataIndex: 'saleCommissionAmount',
          width: 150,
          name: 'showCurrency',
        },
        {
          title: 'Commissions',
          dataIndex: 'commissionAmount',
          width: 140,
          name: 'showCurrency',
        },
        {
          title: 'Brands Payment Status',
          dataIndex: 'status',
          name: 'status',
          width: 200,
        },
      ]
}else if(activeTab.value==2){
  columns.value = [
    {
      title: 'Campaign',
      dataIndex: 'cpcCampaignTitle',
      width: 120,
    },
    {
      title: 'Clicks',
      dataIndex: 'cpcClicks',
      width: 150,
      
    },
    {
      title: 'Commissions',
      dataIndex: 'commissionAmount',
      width: 140,
      name: 'showCurrency',
    },
    {
      title: 'Brands Payment Status',
      dataIndex: 'status',
      name: 'status',
      width: 200,
    }
  ]
}
else if(activeTab.value==3){
  columns.value = [
    {
      title: 'Brand',
      dataIndex: 'brandName',
      width: 120,
    },
    // {
    //   title:'brand Id',
    //   dataIndex: 'brandId',
    //   width: 120,
    // },
    {
      title:'Bonus Program',
      dataIndex: 'accBonusProgramTitle',
      width: 120,
    },
   
    {
      title:'Sales',
      dataIndex: 'saleCommissionAmount',
      width: 120,
      name: 'showCurrency',
    },
    {
      title:'Bonus',
      dataIndex: 'commissionAmount',
      width: 120,
      name: 'showCurrency'
    }
  ]
}
  params.value.groupByType = 'by_brands'
  params.value.page = 1
  params.value.size = 10
  params.value.brandId = null
  getFinancePublisherBillingsDetail()
})
const getFinancePublisherBillingsDetail = async () => {
  spinning.value = true
  const billingBusinessSource=billingBusinessSourceData.value[Number(activeTab.value)]
  const paramsData = { ...params.value, billingId: props.detailData.billingId, brandId: params.value.brandId,billingBusinessSource }
  const res = await financePublisherApi.getFinancePublisherBillingsDetail(paramsData)
  const { success, data } = res
  if (success) {
    listTotal.value = data.total
    list.value = processDataWithId(data.data)

  }
  spinning.value = false
}

watch(() => params.value.brandId, () => {
  params.value.page = 1
 
  getFinancePublisherBillingsDetail()
})

const searchBrand = async keyword => {
  let res, params
  params = {
    keywords: keyword,
    countryCode: COUNTRY_BASE.find(i => i.host === props.marketplace).countryCode,

  }
  res = await publisherReportsApi.getPublisherBrandSearch(params)
  let { success, data } = res
  if (success) {
    data = data.map(item => {
      item.value = item.id
      item.label = item.amazonBrandName
      return item
    })
    brandOptions.value = data
  }
}


const onPageChange = current => {
  params.value.page = current
  getFinancePublisherBillingsDetail()
}

const financePublisherBillingsDetailExport = () => {
  let name = 'ByBrands'
  switch (params.value.groupByType) {
    case 'by_brands':
      name = 'ByBrands'
      break
    case 'by_tracking_id':
      name = 'ByTrackingID'
      break
    case 'by_brands_and_tracking_id':
      name = 'ByBrandsXTrackingID'
      break
  }
  const finalParams = {
    qs: {
      billingId: props.detailData.billingId, keyword: params.value.keyword || '',
      groupByType: params.value.groupByType,
      billingBusinessSource:billingBusinessSourceData.value[Number(activeTab.value)]
    },
    fileName: `payment-${activeTab.value=='0'?'attribution':'associate'}-detail-${moment().format('YYYY-MM-DD')}_${name}.csv`,
  }
  financePublisherApi.financePublisherBillingsDetailExport(finalParams)
}

const toInvoicePdf = () => {
  const { href } = router.resolve({ path: `/publisher/invoice-pdf/${props.detailData.billingId}` })
  window.open(href, '_blank')
}

onBeforeMount(() => {
  getFinancePublisherBillingsDetail()
  if(props.detailData.billingType == 'MONTHLY'){
      columns.value = [
        {
          title: 'Brand',
          dataIndex: 'brandName',
          width: 120,
        },
        {
          title: 'Sales',
          dataIndex: 'saleCommissionAmount',
          width: 150,
          name: 'showCurrency',
        },
        {
          title: 'Commissions',
          dataIndex: 'commissionAmount',
          width: 140,
          name: 'showCurrency',
        },
        {
          title: 'Brands Payment Status',
          dataIndex: 'status',
          name: 'status',
          width: 200,
        },
        {
          title:'ArtemisAdsPaymentStatus',
          dataIndex: 'artemisAdsPaymentStatus',
          width: 200,
        }
      ]
    }
    else{
      columns.value = [
        {
          title: 'Brand',
          dataIndex: 'brandName',
          width: 120,
        },
        {
          title: 'Sales',
          children: [
            {
              title: 'Original',
              dataIndex: 'previousSalesAmount',
              key: 'previousSalesAmount',
              name: 'showCurrency',
            },
            {
              title: 'Adjusted',
              dataIndex: 'finalSalesAmount',
              key: 'finalSalesAmount',
              name: 'showCurrency',
            },
            {
              title: 'Change',
              dataIndex: 'saleCommissionAmount',
              key: 'saleCommissionAmount',
              name: 'amount',
            }
          ],
        },
        {
          title: 'Commissions',
          dataIndex: 'commissionAmount',
          children: [
          {
              title: 'Original',
              dataIndex: 'previousCommissionAmount',
              key: 'previousCommissionAmount',
              name: 'showCurrency',
            },
            {
              title: 'Adjusted',
              dataIndex: 'finalCommissionAmount',
              key: 'finalCommissionAmount',
              name: 'showCurrency',
            },
            {
              title: 'Change',
              dataIndex: 'commissionAmount',
              key: 'commissionAmount',
              name: 'amount',
            }
          ],
        },
        {
          title: 'Brands Payment Status',
          dataIndex: 'status',
          name: 'status',
          width: 200,
        },
        {
          title:'ArtemisAdsPaymentStatus',
          dataIndex: 'artemisAdsPaymentStatus',
          width: 200,
        }
      ]
    }
})
</script>

<style lang="less" scoped>
.amount-plus{
  color: #FF0000 !important;
}
.amount-minus{
  color: #2AAE67 !important;
}
.button-groups{
  display: flex;
  align-items: center;
  
}
.filter-right{
  position: relative;
}
.wenhao-icon{
  position: absolute;
  top: 8.5px;
  right: 40px;
}
.wenhao-icon-wrap{

}
:deep(.indent-level-1) {
  padding-left: 0 !important;
}
.filter-right-group {
  display: flex;
  align-items: center;
  .filter-right {
    margin-right: 16px;
  }
}

.payment {
  .info {
    margin-top: 6px;

    .head {
      display: flex;
      justify-content: space-between;

      >p {
        font-weight: 600;
        font-size: 20px;
        color: var(--dark-1);
        letter-spacing: 0.5px;
        line-height: 28px;
        margin-top: 8px;
      }

      button {
        display: flex;
        align-self: center;

        svg {
          width: 20px;
          height: 20px;
          margin-right: 8px;
          align-self: center;
        }
      }
    }
  }

  .tag {
    display: flex;
    padding: 11px 0 11px 16px;
    background-color: var(--bg-gray-1);
    border-radius: 8px;
    margin-top: 16px;

    .item {
      display: flex;
      width: 230px;

      .line {
        width: 3px;
        height: 40px;
        opacity: 0.85;
        border-radius: 2px;
      }

      .text {
        display: flex;
        flex-direction: column;
        margin-left: 11px;

        .name {
          font-weight: 400;
          font-size: 13px;
          color: var(--dark-2);
          letter-spacing: 0.3px;
          line-height: 18px;
          margin-bottom: 4px;
        }

        .num {
          color: var(--dark-1);
          font-weight: 600;
          font-size: 14px;
          letter-spacing: 0.4px;
          line-height: 20px;
        }
      }
    }

    .date {
      .line {
        background-color: var(--tag-bg-1);
      }
    }

    .amount {
      .line {
        background-color: var(--tag-bg-3);
      }
    }

    .marketplace {
      .marketplace-tag {
        display: inline-block;

        >div {
          display: flex;
          background-color: var(--bg-gray-8);
          border-radius: 4px;
          padding: 0 6px;
          line-height: 20px;

          >svg {
            width: 20px;
            height: 20px;
            margin-right: 4px;
            align-self: center;
          }
        }
      }

      .line {
        background-color: var(--tag-bg-7);
      }
    }

    .payment-id {
      width: 200px;

      .line {
        background-color: var(--tag-bg-2);
      }
    }
    .type {
      .line {
        background-color: #2AAE67;
      }
    }
    .status {
      width: 160px;

      .line {
        background-color: var(--tag-bg-9);
      }
    }
  }

  .detail {
    >p {
      font-weight: 600;
      font-size: 20px;
      color: var(--dark-1);
      letter-spacing: 0.5px;
      line-height: 28px;
      margin-top: 32px;
      margin-bottom: 16px;
    }

    .filter {
      display: flex;
      justify-content: space-between;

      .search {
        display: flex;
        justify-content: space-between;

        button {
          cursor: pointer;
          display: flex;
          margin-left: 16px;

          .jiantou {
            width: 16px;
            height: 16px;
            fill: var(--dark-3);
            margin-left: 8px;
          }

          .daochu {
            width: 20px;
            height: 20px;
            margin-right: 8px;
            fill: var(--dark-1);
          }

          >svg {
            align-self: center;
          }

          >span {
            align-self: center;
          }

          .btn-text {
            align-self: center;
            font-weight: 500;
            line-height: 20px;
            margin-right: 8px;
          }
        }
      }
    }

    .table {
      margin-top: 16px;
    }
  }

}
</style>
